
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icons iconPreset",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 164.118 164.118"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M82.038 1.985c-32.38 0-61.57 19.505-73.96 49.418-12.39 29.913-5.541 64.345 17.354 87.24 31.253 31.316 81.983 31.34 113.267.057 31.284-31.286 31.26-82.015-.055-113.268A79.532 79.532 0 0082.038 1.985zm37.065 38.998A55.118 55.118 0 0084.86 26.77V7.686a74.135 74.135 0 0147.733 19.806zM79.216 26.77A55.106 55.106 0 0045.15 40.826L31.656 27.333a74.125 74.125 0 0147.56-19.647zm2.822 5.572c27.403-.002 49.697 22.292 49.697 49.695s-22.294 49.695-49.697 49.695c-27.403 0-49.698-22.29-49.698-49.695 0-27.404 22.297-49.697 49.698-49.697zM38.325 129.74l6.648-6.648a55.126 55.126 0 0034.243 14.212v19.081a74.112 74.112 0 01-47.732-19.806zm46.535 7.564a55.125 55.125 0 0034.418-14.369l13.487 13.486a74.145 74.145 0 01-47.905 19.967zm38.39-18.378a55.106 55.106 0 0014.055-34.067h19.082a74.13 74.13 0 01-19.645 47.56zm14.058-39.71a55.121 55.121 0 00-14.215-34.244l13.489-13.49a74.12 74.12 0 0119.807 47.733zM27.654 31.31L41.14 44.798a55.125 55.125 0 00-14.37 34.418H7.69a74.137 74.137 0 0119.965-47.905zM7.687 84.86H26.77a55.126 55.126 0 0014.212 34.243l-13.488 13.489A74.129 74.129 0 017.687 84.86zm0 0"}})])
          )
        }
      }
    